module.exports = __webpack_public_path__ + "img/img-header.0502703.webp";